import { ref, computed } from "vue";
import { defineStore } from "pinia";
import useMyFetch from "@stores/useMyFetch";

export const useCampaignTargetsStore = defineStore("campaignTargets", () => {
  const campaignTargets = ref([]);

  async function fetchTargets(token) {
    const { data, response } = await useMyFetch(`/m_campaigns/${token}/campaign_targets`).json();

    if (response.value.ok) {
      campaignTargets.value = data.value;
    }
    return campaignTargets.value;
  }

  const activeTargets = computed(() => campaignTargets.value.filter((target) => target.status === "active"));

  const campaignTargetOptions = computed(() =>
    activeTargets.value.map((target) => ({ label: target.name, value: target.survey_target_id })),
  );

  return {
    fetchTargets,
    campaignTargetOptions,
  };
});
